import styled from "styled-components";

import "../../../../GlobalStyles/Font.css";

export const DeleteAccountUserContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 55px;
`;

export const DeleteAccountUserContainerModel = styled.div`
  max-width: 358px;
  background: #fff;
  border-radius: 20px;
  padding: 16px 20px;
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 684px;
    padding: 30px 40px;
  }
`;

export const TitleModelDeleteAccountUser = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;

  @media (min-width: 1440px) {
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const TitleModelDeleteAccountUserQuestion = styled.p`
  max-width: 250px;
  font-size: 16px;
  font-family: "Exo2 Light";
  line-height: 1.2;
  text-align: justify;

  @media (min-width: 1024px) {
    max-width: 550px;
  }

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.18;
  }
`;

export const ButtonModelDeleteAccountUser = styled.div`
  display: flex;
  gap: 16px;
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;

  @media (min-width: 428px) {
    gap: 34px;
  }

  @media (min-width: 744px) {
    gap: 46px;
  }

  @media (min-width: 1024px) {
    gap: 33px;
  }

  media (min-width: 1440px) {
    gap: 26px;
  }
`;

export const ButtonRedDeleteAccount = styled.button`
  padding: 17px 65px;
  background: #f64747;
  border-radius: 20px;
  color: #fff;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 744px) {
    padding: 17px 49px;
  }

  @media (min-width: 1024px) {
    padding: 17px 39px;
  }

  @media (min-width: 1440px) {
    padding: 10px 104px;
    font-size: 32px;
    font-family: "Exo2 Medium";
    line-height: 1.18;
  }
`;

export const ButtonGreenDeleteAccount = styled.button`
  padding: 17px 65px;
  background: #1ac63f;
  border-radius: 20px;
  color: #fff;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 744px) {
    padding: 17px 49px;
  }

  @media (min-width: 1024px) {
    padding: 17px 39px;
  }

  @media (min-width: 1440px) {
    padding: 10px 104px;
    font-size: 32px;
    font-family: "Exo2 Medium";
    line-height: 1.18;
  }
`;
